export enum BookingStatus {
    AwaitingHaulier = 0,
    AwaitingLoadCompletion = 1,
    AwaitingCompletion = 2,
    Complete = 3,
    Cancelled = 4,
    RequiresOrders = 5
}
